import styled from 'styled-components';

import LogsTooltip from './component';

export default styled(LogsTooltip)`
  width: 650px;
  .tippy-content {
    max-height: 700px;
    overflow: hidden;
    overflow-y: auto;
  }
`;
